module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/try-to-string.js
// module id = 361
// module chunks = 1